import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

import Button from 'components/Button/Button';
import FlexContainer from 'components/FlexContainer/FlexContainer';

export const HeaderStyled = styled(FlexContainer)`
  position: sticky;
  top: 0;
  width: 100%;
  padding: 1.5rem;
  gap: 1rem;
  background: ${({ theme }) => theme.colors.primary.variant1};
  box-shadow: ${({ theme }) => theme.shadows.variant1};
  z-index: 10;
`;

export const LinkStyled = styled(Link)`
  img {
    transition: filter 0.3s;
  }
  &:hover img {
    filter: ${({ theme }) => theme.filters.whiteToViolet};
  }
`;

export const ButtonStyled = styled(Button)`
  padding: 0.5rem;
`;
